import { css } from '@emotion/css';
import { NumberField } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { StoreColourSetting } from 'Shared/backend/settingsPage/ColourSetting';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


/* Seeds the params when the property is first chosen - the '0 0 5px black' glow every venue overlay
   used. */
export const textShadowInitial = {x:0, y:0, blur:5, colour:{literal:'black'}};


const rowStyle = css({
	display:    'flex',
	alignItems: 'center',
	gap:        '0.6em',
	flexWrap:   'wrap',
});

const numStyle = css({
	width: 60,
});


export function TextShadow()
{
	return (
		<StyleFieldsRow>
			<TextShadowFields />
		</StyleFieldsRow>
	);
}


/* The shadow on its own, for a caller that names the location itself - see ruleProperties(). x/y are
   the offset, blur the spread, and colour the (usually translucent or dark) shadow colour. */
export function TextShadowFields()
{
	return (
		<div class={rowStyle}>
			<LabelOnLeftWrap label='X' narrow={true}>
				<NumberField field='x' class={numStyle} />
			</LabelOnLeftWrap>
			<LabelOnLeftWrap label='Y' narrow={true}>
				<NumberField field='y' class={numStyle} />
			</LabelOnLeftWrap>
			<LabelOnLeftWrap label='Blur' narrow={true}>
				<NumberField field='blur' class={numStyle} />
			</LabelOnLeftWrap>
			<StoreColourSetting field='colour' label='Colour' notes='' />
		</div>
	);
}
